"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var cities_1 = __importStar(require("./cities"));
var useTurkeyCities = function () {
    var _a = react_1.useState("Adana"), city = _a[0], setCity = _a[1];
    var _b = react_1.useState([""]), districts = _b[0], setDistricts = _b[1];
    var _c = react_1.useState(""), district = _c[0], setDistrict = _c[1];
    react_1.useEffect(function () {
        if (city) {
            var _city = cities_1.default[city];
            if (_city) {
                setDistricts(_city.districts);
            }
        }
    }, [city]);
    return {
        cities: cities_1.cities,
        city: city,
        setCity: setCity,
        districts: districts,
        district: district,
        setDistrict: setDistrict
    };
};
exports.default = useTurkeyCities;
